module.exports = __webpack_public_path__ + "media/packs/images/flags/TW-c0bea51a2eb3f52748aae7b6a29567b9.svg";